import React, { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import theme from 'src/theme/light';
import { ChangeStateNotaFiscal } from 'src/components/projetos/historico/Historico';
import { PermissionUtil } from 'src/framework/commons/PermissionUtil';
import { Formater, TypeRecords } from 'src/framework/commons/Formater';

interface ComparisonTableProps {
  dados: any[];
  changeState: ChangeStateNotaFiscal;
}

const styles = makeStyles({
  titulo: {
      fontWeight: "bold",
      border: '1px solid grey'
  },
  alterado: {
      backgroundColor: "#BBE6C9",
      border: '1px solid grey'
  },
  removido: {
      backgroundColor: theme.palette.error.light,
  },
  adicionado: {
      backgroundColor: theme.palette.primary.light,
  },
  header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: "bold",
  },
  historico_selecionado: {
      backgroundColor: theme.palette.grey[200],
      border: '1px solid grey'
  },
  icon_alterou : {
      color: theme.palette.warning.main,
      fontSize: "14px"
  },
});

const TabelaComparacaoNotasFiscais: React.FC<ComparisonTableProps> = (props) => {
  const classes = styles();
  const permissoes = PermissionUtil.getPermissions();
  const maskDate = (date: string | Date, datetime: boolean)=>{
    if(date){
        const data = new Date(date);

        if (datetime){
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            });
            return formattedData;
        }else{
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
            });
            return formattedData;
        }    
    }else return "-";
}
  const compareRow = ((campo: string, notas: any, changed: boolean): ReactNode =>{
    switch(campo){
      case "valor":
        return(<>
          {notas.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.valor ? Formater.toString(_historico?.valor, TypeRecords.CURRENCY) : "-"}</TableCell>)
          })}
        </>);
        case "numero":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.numero || "-"}</TableCell>)
            })}
            </>);
        case "peso_bruto":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{(_historico?.peso_bruto && Formater.toString(_historico?.peso_bruto, TypeRecords.CURRENCY).replace("R$", "") +" kg") || "-"}</TableCell>)
            })}
            </>);
        case "itens":
            return(<>
                {notas.map((_historico: any)=>{
                    let bodyItens: ReactNode | null = null;
                    let tableItens: ReactNode | null = null;
                    const itens = _historico.itens;
                    if (itens){
                        bodyItens = itens?.map((comp: any)=>{
                            return(<TableRow key={comp?.codigo}>
                                {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)&&(<TableCell>{comp?.codigo}</TableCell>)}
                                <TableCell align="left">{comp?.quantidade}</TableCell>
                                <TableCell align="left">{comp?.nome}</TableCell>
                                <TableCell align="left">{Formater.toString(Number((comp?.valor) || 0), TypeRecords.CURRENCY) || "-"}</TableCell>
                            </TableRow>)
                        })
                    }
                    if(bodyItens){
                        tableItens = 
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell style={{fontWeight: 'bold'}} align="left">Código</TableCell>)}
                                        <TableCell style={{fontWeight: 'bold'}} align="left">Qtde.</TableCell>
                                        <TableCell style={{fontWeight: 'bold'}} align="left">Descrição</TableCell>
                                        <TableCell style={{fontWeight: 'bold'}} align="left">Valor</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {bodyItens}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tableItens || "-"}</TableCell>)
                })}
            </>);
        case "estado":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.estado || "-"}</TableCell>)
            })}
            </>);
        case "bairro":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.bairro || "-"}</TableCell>)
            })}
            </>);
        case "cidade":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.cidade || "-"}</TableCell>)
            })}
            </>);
        case "complemento":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.complemento || "-"}</TableCell>)
            })}
            </>);
        case "numero_endereco":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.numero_endereco || "-"}</TableCell>)
            })}
            </>);
        case "logradouro":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.logradouro || "-"}</TableCell>)
            })}
            </>);
        case "observacao":
            return(<>
            {notas.map((_historico: any)=>{
                return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.observacao || "-"}</TableCell>)
            })}
            </>);        
      default:
        return(<>
        {notas.map((_historico: any)=>{
          return(
            <TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{"-"}</TableCell>
          )
        })}</>)
    }})
  return (<>
    <TableContainer className='table-historico' sx={{ overflowX: "auto" }}>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    {props.dados.map(_historico=>{
                      return(
                        <TableCell 
                          key={_historico.id}
                          style={{fontWeight: "bold"}}
                        >
                          Nota Fiscal em: {maskDate(_historico?.created_at || "", true)}
                        </TableCell>
                      )
                    })}                    
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Notas Fiscais</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.numero?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Número da nota fiscal</TableCell>
                    {compareRow("numero", props.dados, props?.changeState?.numero?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor total</TableCell>
                    {compareRow("valor", props.dados, props?.changeState?.valor?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.peso_bruto?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Peso bruto</TableCell>
                    {compareRow("peso_bruto", props.dados, props?.changeState?.peso_bruto?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.cidade?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Cidade</TableCell>
                    {compareRow("cidade", props.dados, props?.changeState?.cidade?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.logradouro?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Logradouro</TableCell>
                    {compareRow("logradouro", props.dados, props?.changeState?.logradouro?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.bairro?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Bairro</TableCell>
                    {compareRow("bairro", props.dados, props?.changeState?.bairro?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.numero_endereco?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Número</TableCell>
                    {compareRow("numero_endereco", props.dados, props?.changeState?.numero_endereco?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.complemento?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Complemento</TableCell>
                    {compareRow("complemento", props.dados, props?.changeState?.complemento?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.observacao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Observação</TableCell>
                    {compareRow("observacao", props.dados, props?.changeState?.observacao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.usuario?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Itens</TableCell>
                    {compareRow("itens", props.dados, props?.changeState?.usuario?.hasChanged)}
                </TableRow>
            </TableBody>            
        </Table>
    </TableContainer>
  </>);
};

export default TabelaComparacaoNotasFiscais;
